// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets de la flecha que indica la mano activa
 * @param {*} scene
 */
export function cargaAssetsFlechaMano(scene) {
  // flechaMano
  scene.load.spritesheet(
    'flechaMano',
    ROUTES.rutaBlackJackFlechaMano + '/flechaManoResized-Sheet.png',
    {
      frameWidth: 36,
      frameHeight: 36,
    }
  );
}
